/**
 * Componente de Gráfico de Barras
 * Mostra comparação entre receitas e despesas
 * 
 * IMPORTANTE: Execute 'npm install recharts' antes de usar este componente
 */

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useTheme } from '../context/ThemeContext';

const GraficoBarras = ({ receitas, despesas }) => {
  const { isDarkMode } = useTheme();

  const data = [
    {
      name: 'Resultado',
      Receitas: receitas,
      Despesas: despesas,
    },
  ];

  const formatarMoeda = (valor) => {
    return `R$ ${parseFloat(valor || 0).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? '#404040' : '#e0e0e0'} />
        <XAxis 
          dataKey="name" 
          tick={{ fill: isDarkMode ? '#a0a0a0' : '#6c757d', fontSize: 12 }}
          stroke={isDarkMode ? '#404040' : '#dee2e6'}
        />
        <YAxis 
          tick={{ fill: isDarkMode ? '#a0a0a0' : '#6c757d', fontSize: 12 }}
          stroke={isDarkMode ? '#404040' : '#dee2e6'}
          tickFormatter={formatarMoeda}
        />
        <Tooltip 
          formatter={formatarMoeda}
          contentStyle={{
            backgroundColor: isDarkMode ? '#2d2d2d' : '#ffffff',
            border: `1px solid ${isDarkMode ? '#404040' : '#dee2e6'}`,
            borderRadius: 8,
            color: isDarkMode ? '#e0e0e0' : '#333333'
          }}
        />
        <Legend 
          wrapperStyle={{
            fontSize: 12,
            color: isDarkMode ? '#a0a0a0' : '#6c757d'
          }}
        />
        <Bar dataKey="Receitas" fill="#00B389" radius={[8, 8, 0, 0]} />
        <Bar dataKey="Despesas" fill="#FF4873" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GraficoBarras;
